/* eslint-disable @typescript-eslint/naming-convention */
import { en } from './en'
import { zhHant } from './zh-Hant'

export const languagePack = {
  en: en,
  'zh-Hant': zhHant,
}
